import React from 'react'

interface ExpiryWarningProps {
    planType?: string | null
    balance: string
    deadlineDate: string
    showPlanType?: boolean
}

const ExpiryWarning: React.FC<ExpiryWarningProps> = ({
    planType,
    balance,
    deadlineDate,
    showPlanType = false
}) => {
    return (
        <div className="mt-2 inline-flex ">
            <span className=" text-[12px]   text-gray-600  ">
                *{showPlanType && planType ? `${planType}: ` : ''}Spend {balance} by {deadlineDate}
            </span>
        </div>
    )
}

export default ExpiryWarning
